export default __webpack_public_path__ + "static/media/quickswap@2x.8818e239.png";